import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import FormTypesGroupCategory, {
  IFormTypesGroupCategory
} from "../../../model/formconfiguration/FormTypesGroupCategory";
import FormTypesGroupCategoryForm from "./FormTypesGroupCategoryForm";

export interface State {}

export interface UpdateFormTypesGroupCategoryFormProps
  extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IFormTypesGroupCategory;
}

class UpdateFormTypesGroupCategoryForm extends React.Component<
  UpdateFormTypesGroupCategoryFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;

    registerFormSubmitEventHandler(e => {
      e.preventDefault();

      let updateFormTypeData;

      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateFormTypeData = FormTypesGroupCategory(values);
          updateFormTypeData.code = rowData.code;
        }
      });
      return updateFormTypeData;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FormTypesGroupCategoryForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      ></FormTypesGroupCategoryForm>
    );
  }
}

export default UpdateFormTypesGroupCategoryForm;
